import React from 'react';
import {useRouter} from 'next/router';

import DocumentHeader from '../../components/DocumentHeader';
import ReferralRequestForm from './ReferralRequestForm';
import Waitlist from './Waitlist';
import {useAppContext} from '../../hooks';

export default function JobReferralsNewReferralPage({company}) {
  const {hasJobReferralsAccess} = useAppContext();
  const router = useRouter();

  return (
    <div className="mx-auto max-w-6xl px-4 pt-6 pb-20">
      <DocumentHeader
        title="Submit a Referral Request"
        socialDescription="Request referrals from employees at top tech companies like Google, Facebook, Amazon, and more."
        // TODO: Replace with a job referrals-specific social thumbnail (old: https://static.tryexponent.com/job_referrals_thumbnail_3464d8b8e2.png)
        imgPath="/images/aced_social_thumbnail.png"
      />

      {hasJobReferralsAccess ? (
        <ReferralRequestForm
          company={company}
          isLayoff={router.pathname.includes('layoffs')}
        />
      ) : (
        <Waitlist />
      )}
    </div>
  );
}
